
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { Auth } from 'aws-amplify';
import graph from "@/graph";
import { client } from '@/graph/client';
import { GraphClientMode } from "@/graph/client";
import { MeInfo } from "@/graph/servicecloud/me/types/Get";
import { EventBus } from "@/events/event-bus";

@Component
export default class Sidebar extends Vue {
	@Prop() private msg!: string;

	private connectionModeLocal = true;
	private permissionList: string[] = [];

	get meObject()
	{
		console.log("Sidebar:meObject:called", this.$store.state.meUpdated);
		return this.$store.state.me;
	}

	@Watch("meObject")
	onMeChanged(value: MeInfo | null, oldValue: MeInfo | null) {
		console.log("SIDEBAR::ME", "v:", value, "old:", oldValue);

		if(value)
		{
			this.permissionList = value.permissions;
			this.$forceUpdate();
		}
	}

	hasPermission(perm: string): boolean
	{
		if(this.permissionList.includes(perm) || this.permissionList.includes("AdministratorAccess"))
		{
			return true;
		}

		return false;
	}

	get connectionMode()
	{
		if(client.getMode() === "production")
		{
			this.connectionModeLocal = true;
			return this.connectionModeLocal;
		}
		this.connectionModeLocal = false;
		return this.connectionModeLocal;
	}
	set connectionMode(mode: boolean)
	{
    let label:string = mode ? "Production" : "Stage";
    let value:GraphClientMode = mode ? "production" : "stage";
		console.log("connection mode changed: " + label);
    client.setEndpoint(value);
    this.connectionModeLocal = mode;
    EventBus.$emit("environment-changed", value.toString());
    this.$notify.info('Environment has been changed to: ' + label.toUpperCase());
	}

	async handleUserDropdown(command: string)
	{
		if(command === "logout")
		{
			await this.logout();
		}
	}

	get username()
	{
		return this.$store.state.user.username;
	}

	get currentPath()
	{
		return this.$route.path;
	}

	async logout()
	{
		await Auth.signOut();
	}

	created() {
		console.log("ROUTE");
		console.log(this.$route);
	}

	mounted() {
		if(client.getMode() === "production")
		{
			this.connectionModeLocal = true;
		}
		else
		{
			this.connectionModeLocal = false;
		}
	}
}
